import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { selectNavigationItems, NavigationItem } from 'src/app/store/navigation';
import { selectSettingsState } from 'src/app/store/settings';
import { FarmService } from 'src/app/services/farm-service.service';
import { Session } from 'protractor';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

declare const $: any;

@Component({
  selector: 'smart-nav',
  templateUrl: './nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavComponent {

  arrNav : any = [];
  menuFarm: any;
  show = false;
  menuActive: any;
  menuSubFarm: any;
  farmmenu: any;
  plotmenu: any;

  vm$ = this.store.select(
    createSelector(
      selectNavigationItems,
      selectSettingsState,
      (items, settings) => ({ items, minified: settings.minifyNavigation })
    )
  );
  

  constructor(
    private store: Store<any>,
    private farmService: FarmService,
    private router: Router,
    private spinner: NgxSpinnerService,
    ) { }

  trackByFn(idx: number, item: NavigationItem) {
    //console.log("trackByFn",item);
    return item.title + '_' + idx;
  }

  ngOnInit() {

    // //console.log("vm.items",this.vm.items);
    // this.getInit();
  }

  
}
